module.exports = __webpack_public_path__ + "img/bg1.a7783cc4.jpg";